<div #sideMenu *ngrxLet="sharedFacade.isLoaded$ as dataLoaded">
  <ngb-accordion
    class="sidebar-accordion"
    style="overflow: auto"
    [closeOthers]="closeOthers"
    [activeIds]="activeIdsMain"
    #accordion="ngbAccordion"
    id="reportElement"
  >
    <ngb-panel
      ngbPanelToggle="accordion"
      class="custom-cLass"
      *ngFor="let children of menuItems; let index = index"
      id="panel-main-{{ index }}"
    >
      <ng-template *ngIf="children?.submenu" ngbPanelTitle>
        <img [src]="children.isActive ? children.activeImg : children.icon" alt="scenario" />
        <a
          (click)="navigate(children, children?.submenu, children.link)"
          class="menutext"
          [joyrideStep]="'step5-' + index"
          (prev)="onPrev(index)"
          (next)="onNext(index)"
          [title]="index == 1 ? 'Package' : 'Report'"
          [text]="index == 1 ? guideTourStep5Str : guideTourStep6Str"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <span [ngClass]="children.isActive ? 'activeClass' : ''" class="parent-span-submenu">{{
            children.text
          }}</span>
        </a>
      </ng-template>
      <ng-template *ngIf="!children?.submenu" ngbPanelHeader>
        <div class="vert-align">
          <img
            (click)="collapsePanel(children, children.link)"
            [src]="children.isActive ? children.activeImg : children.icon"
            alt="scenario"
          />
          <a
            routerLink="{{ children.link }}"
            class="menutext"
            routerLinkActive="active"
            (click)="collapsePanel(children, children.link)"
          >
            <span class="parent-span-header">{{ children.text }}</span>
          </a>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <ngb-accordion
          class="sidebar-child-accordion"
          [closeOthers]="closeOthers"
          #childaccord="ngbAccordion"
          [activeIds]="joyrideService.isTourInProgress() ? 'panel-sub-0' : activeIdsSub"
        >
          <ngb-panel
            panelClass="custom-panel"
            *ngFor="let children2 of children.submenu; let index2 = index"
            [disabled]="false"
            id="panel-sub-{{ index2 }}"
            >{{ children2.text }}>
            <ng-template *ngIf="children2?.submenu" ngbPanelTitle>
              <!-- FOR SCENARIO NAMES -->
              <a
                class="dropdown-item iconify text-ellipsis scenario-name"
                routerLinkActive="active"
              >
                <span
                  class="child-span-submenu"
                  [ngClass]="
                    children.isActive &&
                    !currentRoute.includes('scenario-list') &&
                    children2?.scenarioId == scenarioId
                      ? 'activeScenarioClass'
                      : ''
                  "
                  [title]="children2?.text + ' also considered as ' + children2?.shortName"
                >
                  {{ children2.text }}</span
                >
              </a>
            </ng-template>
            <ng-template *ngIf="!children2?.submenu" ngbPanelHeader>
              <!-- Report submenus -->
              <!-- Feature Lock wrapper for Interpretation -->
              <app-feature-lock
                *ngIf="children2.link === 'interpretation'"
                [featureCode]="FeatureCodes.REPORTS_INTERPRETATION_SECTION"
                [isDisabled]="!hasInterpretationAccess"
                [popupPosition]="'bottom-right'"
                [showProBadge]="false"
              >
                <a
                  class="dropdown-item iconify text-ellipsis-report no-gradient"
                  (click)="handleInterpretationClick($event, children, children2)"
                >
                  <span
                    (prev)="onPrevReports(index2, children2.link)"
                    (done)="onComplete()"
                    [ngClass]="children2.isActive ? 'activeClass' : ''"
                    title="{{ children2.text }}"
                    (next)="onNext(index2, children2.link)"
                    class="child-span-header"
                    [text]="'A new optional advanced reporting stage.'"
                    [joyrideStep]="'step28-' + children2.link.toLowerCase()"
                  >
                    {{ children2.text }}
                    <app-crown-icon
                      *ngIf="!hasInterpretationAccess"
                      [size]="14"
                      [showBadge]="false"
                    >
                    </app-crown-icon>
                  </span>
                </a>
              </app-feature-lock>

              <!-- Regular menu items without feature lock -->
              <a
                *ngIf="children2.link !== 'interpretation'"
                class="dropdown-item iconify text-ellipsis-report"
                (click)="navigate(children, children2, children2.link)"
              >
                <span
                  (prev)="onPrevReports(index2, children2.link)"
                  (done)="onComplete()"
                  [ngClass]="children2.isActive ? 'activeClass' : ''"
                  title="{{ children2.text }}"
                  (next)="onNext(index2, children2.link)"
                  class="child-span-header"
                  [text]="
                    index2 == 0
                      ? 'Generate your chart at a glance then skip the \'Interpretation\' stage to generate your streamlined LCA report.'
                      : index2 == 2
                      ? 'Generate the report and view your results! Remember you can always go back to edit or add anything you\'ve missed.'
                      : 'A new optional advanced reporting stage.'
                  "
                  [joyrideStep]="'step28-' + children2.link.toLowerCase()"
                  >{{ children2.text }}</span
                >
              </a>
            </ng-template>
            <ng-template *ngIf="children2.submenu" ngbPanelContent>
              <div
                class="offset-1"
                *ngFor="let children3 of children2.submenu; let i = index; let isLast = last"
              >
                <a
                  (click)="navigate(children, children2, children3.link)"
                  class="btn content w-100"
                  routerLink="{{ children3.link }}"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{
                    active:
                      children2.scenarioId == scenarioId && router.url.includes(children3.link),
                    isDisabled: !children2.palletConfigurationUpdated && i !== 0
                  }"
                >
                  <span
                    class="child-span-links"
                    [title]="
                      i == 1
                        ? 'Materials'
                        : i == 3
                        ? 'Product'
                        : i == 7
                        ? 'End-of-life'
                        : i == 0
                        ? 'Configuration'
                        : ''
                    "
                    [joyrideStep]="'step11-' + children3.text.toLowerCase()"
                    (prev)="onPrev(i, children3.text)"
                    [text]="
                      i == 1
                        ? guideTourStep11Str
                        : i == 3
                        ? guideTourStep12Str
                        : isLast
                        ? guideTourStep13Str
                        : i == 0
                        ? guideTourStep14Str
                        : i == 4
                        ? guideTourStep26Str
                        : ''
                    "
                    [id]="children3.text.toLowerCase()"
                    (next)="onNext(i, children3.text)"
                    title="{{ children3.text }}"
                    >{{ children3.text }}</span
                  ></a
                >
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
